const LANDMARK_TAGS = new Set([
	'NAV',
	'MAIN',
	'HEADER',
	'FOOTER',
	'ASIDE',
	'SECTION',
	'FORM',
])

const LANDMARK_ROLES = new Set([
	'navigation',
	'main',
	'banner',
	'contentinfo',
	'complementary',
	'region',
	'search',
	'form',
])

const HIDDEN_TEXT_SELECTORS = [
	'[id^="sro-"]',
	'.sr-only',
	'.acsb-sr-only',
	'[aria-hidden="true"]',
].join(', ')

const isLandmarkElement = (element: Element): boolean => {
	if (LANDMARK_TAGS.has(element.tagName)) return true
	const role = element.getAttribute('role')
	return role ? LANDMARK_ROLES.has(role) : false
}

const getVisibleText = (element: HTMLElement): string => {
	const clone = element.cloneNode(true) as HTMLElement
	clone.querySelectorAll(HIDDEN_TEXT_SELECTORS).forEach((node) => node.remove())
	return clone.textContent?.replace(/\s+/g, ' ').trim() ?? ''
}

/**
 * Removes aria-label from anchor tags in CMS HTML when visible link text is present.
 * The CMS "aria_label" field stores address markup; editors may add aria-label by mistake.
 */
export const stripAriaLabelFromAnchorTags = (html: string): string => {
	return html.replace(/\saria-label=(["'])(?:\\.|(?!\1)[^\\])*\1/gi, '')
}

/**
 * Removes aria-label from interactive elements that already expose visible text.
 * Keeps aria-label on icon-only controls and on landmark elements (nav, main, etc.).
 */
export const fixTextLinkAriaLabels = (root: ParentNode = document.body): void => {
	root.querySelectorAll('a[aria-label], button[aria-label]').forEach((element) => {
		const htmlElement = element as HTMLElement

		if (isLandmarkElement(htmlElement)) return

		const visibleText = getVisibleText(htmlElement)
		if (!visibleText) return

		htmlElement.removeAttribute('aria-label')
		htmlElement
			.querySelectorAll('[id^="sro-"]')
			.forEach((node) => node.remove())
	})
}
